import axios from "axios";

const baseURL = process.env.REACT_APP_IPIFY_API;
const api = axios.create({ baseURL });

interface IpifyType {
    ip: string | undefined
}

export const getIp = async () => {
    console.log(baseURL);
    const { data } = await api.get<IpifyType>('');
    return data.ip;
}